import { ParametricAssetId, type ParametricAsset } from "@/types";

type AssetParams = {
  L: number; // Largeur
  H: number; // Hauteur
};

const asset: ParametricAsset<AssetParams> = {
  id: ParametricAssetId.RECTANGLE,
  image: "/images/assets/rectangle.svg",
  inputs: [
    { key: "L", type: "dimension" },
    { key: "H", type: "dimension" },
  ],
  build: (params, offset) => {
    const { L, H } = params;
    return [
      {
        type: "polyline",
        points: [
          [offset[0] - L / 2, offset[1] - H / 2, offset[2]], // bas-gauche
          [offset[0] + L / 2, offset[1] - H / 2, offset[2]], // bas-droit
          [offset[0] + L / 2, offset[1] + H / 2, offset[2]], // haut-droit
          [offset[0] - L / 2, offset[1] + H / 2, offset[2]], // haut-gauche
          [offset[0] - L / 2, offset[1] - H / 2, offset[2]], // fermeture
        ],
      },
    ];
  },
};

export default asset;
